import React, { useEffect, useState } from 'react';
import { getManagers } from '../../api/managerApi';
import { Link } from 'react-router-dom';

const ManagerList = () => {
  const [managers, setManagers] = useState([]);

  const isActive = (value) => value === true || value === 1 || value === '1' || value === 'true';

  useEffect(() => {
    getManagers().then(setManagers);
  }, []);

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>회사 목록</h2>
        <Link to="/manager/create" className="btn btn-primary">신규 회사 등록</Link>
      </div>
      <table className="table table-bordered table-hover">
        <thead className="table-light">
          <tr>
            <th>회사코드</th>
            <th>회사명</th>
            <th>도메인</th>
            <th>DB명</th>
            <th>DB호스트</th>
            <th>활성</th>
            <th>관리</th>
          </tr>
        </thead>
        <tbody>
          {managers.map(manager => (
            <tr key={manager.M_ComCode}>
              <td><Link to={`/manager/${manager.M_ComCode}`} className="text-decoration-none fw-bold">{manager.M_ComCode}</Link></td>
              <td>{manager.M_ComName}</td>
              <td>{manager.M_Domain}</td>
              <td>{manager.M_DBName}</td>
              <td>{manager.M_DBHost}</td>
              <td>{isActive(manager.is_active) ? 'O' : 'X'}</td>
              <td>
                <Link to={`/manager/edit/${manager.M_ComCode}?mode=basic`} className="btn btn-sm btn-outline-info me-2">기본편집</Link>
                <Link to={`/manager/edit/${manager.M_ComCode}?mode=portlet`} className="btn btn-sm btn-outline-primary me-2">포틀릿편집</Link>
                <Link to={`/manager/edit/${manager.M_ComCode}?mode=menu`} className="btn btn-sm btn-outline-success">메뉴편집</Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ManagerList;
